import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import QRCode from 'react-qr-code';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Modal } from '../../../../components/Modal';
import { selectWork } from '../../../Api/selectors';
import { REQUEST_VEHICLE_PROPERTY_UPDATE, VEHICLE_OPTIONS, VEHICLE_OPTIONS2 } from '../../constants';
import { GeneratePdfButton } from '../../../../components/GeneratePdfButton/GeneratePdfButton';
import { HBox, VBox } from '../../../../components/Box';
import { selectAllOptions } from '../../selectors';
import { formatCurrencyValue, formatLicensePlate } from '../../../../utils/string';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';
import { PriceCardFooter } from './PriceCardFooter';
import { Loader } from '../../../../components/Loader';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: start;
  font-size: 18px;
  margin: 10px auto;
  font-family: arial;
  width: 1240px;
  height: 1754px;
  color: black;

  .doc-main {
    width: 97%;
    max-width: 1240px;
    background-color: #fff;
    color: black;
    font-weight: 400;
    padding: 100px 20px 10px 0px;
    .container {
      width: 87%;
      max-width: 1240px;
    }
  }

  .grey-container {
    background-color: #f1f2f5;
    // margin-top: 20px;
  }

  .hero-section {
    display: grid;
    grid-template-columns: 65% 32%;
    grid-column-gap: 3%;

    & .hero-image {
      object-fit: 'contain';
      height: 510px;
    }
  }
  .title {
    font-size: 48px;
    text-transform: capitalize;
  }

  .title1 {
    font-size: 28px;
  }

  .option-title {
    padding-left: 40px;
    margin-bottom: 8px;
    font-size: 24px;
  }

  .vehicle-info-section {
    display: grid;
    grid-template-columns: 24% 24% 24% 24%;
    grid-template-rows: 60px 60px;
    grid-row-gap: 30px;
    width: 100%;
    margin-bottom: 36px;
    padding: 20px 0px 10px 40px;
    font-size: 20px;
    border-bottom: 1px solid #c73d36;

    .info-label {
      font-size: 16px;
      text-transform: uppercase;
      font-weight: 600;
      color: #bc2228;
    }

    .info-value {
      text-transform: capitalize;
      color: #191919;
    }
  }
  .options-section {
    padding-left: 40px;
    font-size: 20px;
    margin-bottom: 80px;
    text-transform: capitalize;
    min-height: 460px;
  }

  .b2b-price-section {
    align-items: baseline;
    margin-bottom: 48px;
    color: #fff;
  }

  .price-incl-options {
    width: 50%;
    font-size: 24px;
    margin-bottom: 20px;
    color: #fff;
  }

  .image-container {
    width: 700px; /* Set the width to 100px */
    overflow: hidden; /* Hide the overflow beyond the container */
  }

  .image-container img {
    height: auto; /* Maintain the image's aspect ratio */
  }

  .wegenbelasting {
    width: 50%;
    font-size: 24px;
    margin-bottom: 20px;
    align: left;
    color: #fff;
  }
`;

const STATE = {};

const numberOfVehicleOptions = VEHICLE_OPTIONS ? VEHICLE_OPTIONS.length : 0;

/* eslint-disable react/prefer-stateless-function */
class PdfPreviewComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  get leftFrontImageUrl() {
    const url = this.props.vehicle?.documents?.find(d => d.type === 'photo_interior_general_0 left_front')?.url;
    return url;
  }

  roadTax(str) {
    if (!str) return { min: 0, max: 0 };

    // € 67 / € 268 or € 229 / € 916
    let arr1 = str
      .split('/')[1]
      .split(/[^\d]+/)
      .filter(Boolean)
      .map(s => parseInt(s, 10));

    return {
      min: Math.min(...arr1), // Get the minimum value
      max: Math.max(...arr1), // Get the maximum value
    };
  }

  renderOption(value, index) {
    if (value.title) {
      return null;
    }

    let options = this.props.allOptions?.filter(o => o.name.toLowerCase() === value.toLowerCase());

    let vehicleHasOption;
    let optionsRendered = 0; // Counter for options rendered

    for (let i = 0; i < options?.length || 0; i++) {
      for (let j = 0; j < this.props.vehicle.options?.length || 0; j++) {
        let o1 = options[i];
        let o2 = this.props.vehicle.options[j];
        if (o1.id == o2.id && o2.VehicleHasOption.isSelected) {
          vehicleHasOption = o2;
          if (value == 'airco') {
            //
          }
        }
      }
    }

    if (vehicleHasOption) options = this.props.allOptions?.find(o => o.autotelexId == vehicleHasOption.autotelexId);

    vehicleHasOption = vehicleHasOption?.VehicleHasOption?.isSelected ? vehicleHasOption : null;

    if (!vehicleHasOption) return null;

    // Check if the maximum number of options has been rendered
    if (optionsRendered < 12) {
      optionsRendered++;

      return (
        <div style={{fontSize: '150%', width: '50%', marginBottom: '10px' }}>
          {' '}
          <span style={{fontSize: '150%', fontWeight: 600, marginRight: '8px' }}>&#10003;</span>
          {value}
        </div>
      );
    } else {
      return null; // Return null for options beyond the first 12
    }
  }

  render() {
    const vehicle = this.props.vehicle;
    const brandAndModel = `${vehicle.brand_name ?? ''} ${vehicle?.model_name ?? ''}`;
    const truncatedBrandAndModel = truncateAndExcludeLastWord(brandAndModel, 24);
    const modelInfo = `${vehicle.model_info ?? ''}`;
    const truncatedModelInfo = truncateAndExcludeLastWord(modelInfo, 24);
    const lowestNumber = getLowestNumber(`${vehicle.wegenbelasting ?? '0'}`);
    // TODO Avoid the problem with missed vehicle_purpose in vehicle object
    // Check /modules/Vehicles/helpers.js line 41: v.vehicle_purpose = null;
    const vehiclePurpose =
      vehicle?.properties?.find(p => p?.propertyName?.name === 'vehicle_purpose')?.propertyValue?.value ?? null;
      const optionsLength = (VEHICLE_OPTIONS
        ?.map((value, index) => this.renderOption(value, index))
        .filter(Boolean)
        .length
        );
        const numberShown = 24 - optionsLength
    return (
      <Modal pdfView onClose={this.props.onClose}>
        {this.state.isLoading ? (
          <Modal>
            <HBox center vCenter>
              <Loader />
            </HBox>
          </Modal>
        ) : (
          <Container>
            <VBox id={'pricecard_doc'} center vCenter className="doc-main">
              <div className="container">
                <HBox className="hero-section">
                  <div class="image-container">
                    <img src={this.leftFrontImageUrl} alt="Vehicle general image" className="hero-image" />
                  </div>
                  <VBox style={{ backgroundColor: '#333333', height: '100%', paddingLeft: '20px', paddingTop: '30px' }}>
                    {vehiclePurpose === 'commercial' ? (
                      vehicle?.financial_price_b2c ? (
                        <VBox left className="b2b-price-section">
                          <h2 style={{ fontSize: '50px' }}>{formatCurrencyValue(vehicle?.financial_price_b2c)},-&nbsp;</h2>
                          {vehicle.tax_type !== 'marge' ? (
                            <span style={{ fontSize: '20px' , fontSize: '150%' }}>{this.lbl('vehicle.details.pdf.excl-btw')}</span>
                          ) : (
                            ''
                          )}
                        </VBox>
                      ) : (
                        <VBox left className="b2b-price-section">
                          <h2 style={{ fontSize: '50px' }}>€ ---,-</h2>
                          {vehicle.tax_type !== 'marge' ? (
                            <span style={{ fontSize: '20px', fontSize: '150%' }}>{this.lbl('vehicle.details.pdf.excl-btw')}</span>
                          ) : (
                            ''
                          )}
                        </VBox>
                      )
                    ) : vehicle?.financial_price_b2c ? (
                      <VBox left className="b2b-price-section">
                        <h2 style={{ fontSize: '50px' }}>{formatCurrencyValue(vehicle?.financial_price_b2c)},-&nbsp;</h2>
                        {vehicle.tax_type !== 'marge' ? (
                          <span style={{ fontSize: '20px' , fontSize: '150%'}}>{this.lbl('vehicle.details.pdf.incl-btw')}</span>
                        ) : (
                          ''
                        )}
                      </VBox>
                    ) : (
                      <VBox left className="b2b-price-section">
                        <h2 style={{ fontSize: '50px' }}>€ ---,-</h2>
                        {vehicle.tax_type !== 'marge' ? (
                          <span style={{ fontSize: '20px' , fontSize: '150%' }}>{this.lbl('vehicle.details.pdf.incl-btw')}</span>
                        ) : (
                          ''
                        )}
                      </VBox>
                    )}

                    <div style={{ textAlign: 'left', width: '100%' }}>
                      {vehicle?.wegenbelasting ? (
                        <>
                          <VBox className="wegenbelasting">
                            <div style={{ width: '300px',  fontSize: '105%'}}>
                              <b>{this.lbl('vehicle.details.pdf.wegenbelasting')}: </b>
                            </div>
                            <div style={{ width: '300px', fontSize: '105%' }}>
                              {formatCurrencyValue(lowestNumber)},-&nbsp;
                              {this.lbl('vehicle.details.pdf.perkwartaal')}
                            </div>
                          </VBox>{' '}
                        </>
                      ) : (
                        <HBox className="wegenbelasting">
                          <div style={{ width: '300px', fontSize: '105%' }}>
                            <b>,-&nbsp;</b>
                          </div>
                          <div style={{ width: '300px', fontSize: '105%' }}></div>
                        </HBox>
                      )}
                      {vehicle?.catalogprice_incl_options ? (
                        <>
                          <VBox className="price-incl-options">
                            <div style={{ width: '300px', fontSize: '105%' }}>
                              <b>{this.lbl('vehicle.details.pdf.price-incl-opt')}:</b>
                            </div>
                            <div style={{ width: '300px' , fontSize: '105%' }}>
                              {formatCurrencyValue(vehicle?.catalogprice_incl_options)},-&nbsp;
                            </div>
                          </VBox>
                        </>
                      ) : (
                        <VBox className="price-incl-options">
                          <div style={{ width: '300px' }}>&nbsp;</div>
                          <div style={{ width: '300px' }}></div>
                        </VBox>
                      )}
                    </div>
                  </VBox>
                </HBox>
                <h1 className="white">
                  <span className="title">{truncatedBrandAndModel} &nbsp;</span>
                </h1>
                <span className="title1">{truncatedModelInfo}</span>
                <VBox className="grey-container">
                  <div left className="vehicle-info-section">
                    {[
                      // 'regplate',
                      'transmission_type',
                      'fuel_type',
                      'date_first_allowance',
                      'mileage',
                      'tax_type',
                      'cyllinder_capacity',
                      'power',
                      'rDWEuroklasse',
                      // 'vin',
                    ].map(property => {
                      return (
                        vehicle[property] && (
                          <VBox key={property}>
                            <div className="info-label">{this.lbl(`vehicle.property.pricecard.${property}`)}:</div>
                            <div
                              className="info-value"
                              style={{ textAlign: 'left', fontSize: '150%', width: '50%', textTransform: 'capitalize' }}
                            >
                              {property === 'regplate'
                                ? formatLicensePlate(vehicle.regplate)
                                : property === 'mileage'
                                ? parseInt(vehicle.mileage || '0').toLocaleString() + ' km'
                                : property === 'transmission_type'
                                ? vehicle.transmission_type === 'automatic'
                                  ? 'Automatisch'
                                  : 'Manueel'
                                : vehicle[property]}
                            </div>
                          </VBox>
                        )
                      );
                    })}
                  </div>

                  <div className="option-title">
                    <strong>{this.lbl('vehicle.details.pdf.options')}:</strong>{' '}
                  </div>
                  <HBox className="options-section">
                  <HBox classname="capitalize-first-letter" flexWrap>
                      {VEHICLE_OPTIONS
                        ?.map((value, index) => this.renderOption(value, index))
                        .filter(Boolean)
                        .slice(0, 24)}
                       
                        {optionsLength < 10 && 
                       
                       VEHICLE_OPTIONS2
                        ?.map((value, index) => this.renderOption(value, index))
                        .filter(Boolean)
                        .slice(0, numberShown)
                       }    
                             </HBox>
                    <div style={{ height: 'auto', maxWidth: '250px', width: '250px', fontSize: '125%'}}>
                      {' '}
                      {env.clientId === AppClientId.AUTOWIENTJES ? (
                        <QRCode
                          size={400}
                          style={{ height: 'auto', maxWidth: '60%', width: '60%' }}
                          value={`https://www.autowientjes.nl/occasions/?merk=${vehicle?.brand_name.replace(/ /g, '-')}`}
                          viewBox={`0 0 256 256`}
                        />
                      ) : env.clientId === AppClientId.HARRY_NIJBOER ? (
                        <QRCode
                          size={400}
                          style={{ height: 'auto', maxWidth: '60%', width: '60%' }}
                          value={`https://www.harrynijboer.nl/occasions?brand=${vehicle?.brand_name.replace(/ /g, '-')}`}
                          viewBox={`0 0 256 256`}
                        />
                      ) : env.clientId === AppClientId.AUTOHUISSALLAND ? (
                        <QRCode
                          size={400}
                          style={{ height: 'auto', maxWidth: '60%', width: '60%' }}
                          value={`https://www.autohuissalland.nl/aanbod-occasions`}
                          viewBox={`0 0 256 256`}
                          bgColor={'#F1F2F5'}
                        />
                      ) : null}
                    </div>
                  </HBox>

                  <HBox style={{ backgroundColor: '#fff' }}>
                    <PriceCardFooter footerText={env.pricecard_footer_text} />
                  </HBox>
                </VBox>
              </div>
            </VBox>
          </Container>
        )}
        <GeneratePdfButton
          //generateDirectly
          sectionId={'pricecard_doc'}
          label={'PDF'}
          widthMn={210}
          heightMm={297}
          closeModal={this.props.onClose}
          setLoading={loading => this.setState({ isLoading: loading })}
        />
      </Modal>
    );
  }
}

PdfPreviewComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  vehicle: PropTypes.object,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loadingChecks: selectWork(REQUEST_VEHICLE_PROPERTY_UPDATE),
    allOptions: selectAllOptions(),
  });

function truncateAndExcludeLastWord(inputString, maxLength) {
  // Controleer of de inputString de maximale lengte niet overschrijdt
  if (inputString.length <= maxLength) {
    return inputString;
  }

  // Zoek de laatste spatie vóór de maximale lengte
  let lastSpaceIndex = inputString.lastIndexOf(' ', maxLength);

  // Als er geen spatie is gevonden, gebruik dan de maximale lengte
  if (lastSpaceIndex === -1) {
    lastSpaceIndex = maxLength;
  }

  // Knip de string af op het laatste spatiepunt
  const truncatedString = inputString.substring(0, lastSpaceIndex);

  return truncatedString;
}

function getLowestNumber(inputString) {
  // Extract numbers from the input string
  const numbers = inputString.match(/\d+/g);

  // Convert the extracted numbers to an array of integers
  const numericValues = numbers.map(value => parseInt(value, 10));

  // Find the minimum value
  const min = Math.min(...numericValues);

  return min;
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const PdfPreview = compose(withConnect, withRouter)(PdfPreviewComp);
